var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWinter = function SvgWinter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.026 17.43A8.003 8.003 0 0 1 8.999 2a8.003 8.003 0 0 1 7.458 5.099 5.5 5.5 0 0 1 1.542 10.879 6 6 0 0 0-11.973-.549v.001Zm6.973-1.163 1.964-1.134 1 1.732L13.999 18l1.964 1.134-1 1.732-1.964-1.134V22h-2v-2.268l-1.964 1.134-1-1.732L9.999 18l-1.964-1.134 1-1.732 1.964 1.134V14h2v2.268-.001Z",
    fill: "#292A2C"
  })));
};
export default SvgWinter;